import LenderBusinessDetail from "./LenderBusinessDetails";

export default LenderBusinessDetail;
